import { useFormik } from "formik";
import React, { useEffect, useState } from "react";
import Logo from "../../assets/logo.svg";
import FormInput from "../../components/form/FormInput";
import useAuth from "../../controller/auth-controller";
import {
  clearLoginData,
  getCookie,
  getLoginData,
  setLoginData,
} from "../../utils/session";
import "./login.scss";
import { validationSchema } from "./validationSchema";
import { toast } from "react-toastify";
import Button from "../../components/buttton/button";
import Tooltip from "rc-tooltip";

const Login = () => {
  const authController = useAuth();
  const { succMsg, isLoading, errMsg, login } = authController;
  const [isChecked, setChecked] = useState(false);

  useEffect(() => {
    const isLogin = getCookie("isLogin");
    if (isLogin) {
      window.location.href = "/home";
    }

    const loginData = getLoginData();
    if (loginData?.username) {
      formik.setValues(loginData);
      setChecked(true);
    }
  }, []);

  useEffect(() => {
    const isLogin = getCookie("isLogin");
    if (succMsg && isLogin) {
      toast.success(succMsg);
      handleRememberMe();
      window.location.href = "/home";
    }
  }, [succMsg]);

  useEffect(() => {
    if (errMsg) {
      toast.error(errMsg);
      handleRememberMe();
    }
  }, [errMsg]);

  const formik = useFormik({
    initialValues: {
      username: "",
      password: "",
    },
    validationSchema,
    enableReinitialize: true,
    onSubmit: (values) => {
      const data = values;
      login({ data });
    },
  });

  const handleRememberMe = () => {
    if (isChecked) {
      setLoginData(formik?.values);
    } else {
      clearLoginData();
    }
  };

  return (
    <>
      <div className="login-container h-[var(--vh)] flex justify-center items-center	bg-center bg-no-repeat bg-cover overflow-hidden">
        <section className="wrapper bg-white-100 flex flex-col md:rounded p-10 md:px-10 px-5 w-[100vw] md:w-[500px] md:h-fit h-[var(--vh)] w-100">
          <img src={Logo} alt="logo-icon" className="md:m-auto mx-auto my-3" />
          <form
            id="loginForm"
            onSubmit={formik.handleSubmit}
            className=" md:my-0 my-auto"
          >
            <div className="formWrapper my-8 mb-6">
              <div className="title mb-5">
                <p className="font-bold text-base uppercase	mb-1 text-black-100">
                  FSO Portal Login
                </p>
              </div>
              <FormInput
                label="Username"
                dom={{
                  type: "text",
                  name: "username",
                  onChange: (e) => {
                    formik.setFieldValue("username", e.target.value, true);
                  },
                  value: formik.values.username,
                  placeholder: "username",
                  className: "p-3",
                }}
                required={true}
                error={
                  formik.touched.username && Boolean(formik.errors.username)
                }
                errorMessage={formik.touched.username && formik.errors.username}
                wrapperClass="mb-4"
                fullwidth={true}
              />
              <FormInput
                label="Password"
                dom={{
                  type: "password",
                  name: "password",
                  onChange: (e) => {
                    formik.setFieldValue("password", e.target.value, true);
                  },
                  value: formik.values.password,
                  placeholder: "password",
                  className: "p-3",
                }}
                required={true}
                error={
                  formik.touched.password && Boolean(formik.errors.password)
                }
                errorMessage={formik.touched.password && formik.errors.password}
                wrapperClass="mb-4"
                fullwidth={true}
              />
              <div className="mb-10 flex justify-between">
                <div
                  className="flex cursor-pointer"
                  onClick={() => {
                    setChecked && setChecked(!isChecked);
                  }}
                >
                  <input
                    type="checkbox"
                    className="cursor-pointer"
                    checked={isChecked}
                  />
                  <p className="text-sm ml-1">Rememeber me</p>
                </div>
                <div className="forgotPass cursor-pointer">
                  <Tooltip
                    placement="bottomRight"
                    overlay={
                      <div className="text-black-100">
                        If you need to reset your password, please contact FMI
                        Ltd. at
                        <span className="text-primary ms-1">
                          it@freemansgroup.com.
                        </span>
                      </div>
                    }
                    overlayClassName="md:w-[20vw] w-[89vw] opacity-100"
                    overlayInnerStyle={{
                      backgroundColor: "#F4F3F4",
                      left: "100%",
                      borderRadius: "4px",
                    }}
                  >
                    <p>Forgot password?</p>
                  </Tooltip>
                </div>
              </div>
            </div>
            <Button loader={isLoading} className="h-12 text-sm" type="submit">
              Login
            </Button>
          </form>
        </section>
      </div>
    </>
  );
};

export default Login;
